module.exports = __webpack_public_path__ + "static/media/i4.e161adc4.jpg";